<template>
    <b-container>
        <h1 class="text-center pt-4 pb-4">{{ $t("title.cleanup") }}</h1>

        <b-row v-if="success" class="text-center pt-4">
            <b-col>
                <b-alert show variant="success">
                    <p>{{ $t("info.successgeneric") }}</p>
                </b-alert>
            </b-col>
        </b-row>

        <div v-else>
            <div v-if="spinner" class="text-center">
                <b-spinner style="width: 3rem; height: 3rem" variant="success" label="Spinning"
                    disabled="labelStatus"></b-spinner>
            </div>

            <div>
                <b-row class="mt-2">
                    <b-col sm="4" class="mt-4">
                        <b-form-select v-model.trim="$v.building.$model" :options="buildings"></b-form-select>
                        <div class="text-danger" v-if="!$v.building.required && $v.building.$dirty">{{ $t("info.required") }}
                        </div>
                    </b-col>
                </b-row>
            </div>

            <div>
                <b-row class="mt-2">
                    <b-col sm="4" class="mt-4">
                        <b-form-select v-model.trim="$v.cleanUp.$model" :options="cleanUpTypeList"></b-form-select>
                        <div class="text-danger" v-if="!$v.cleanUp.required && $v.cleanUp.$dirty">{{ $t("info.required") }}</div>
                    </b-col>
                </b-row>
            </div>

            <b-row class="mt-2">
                <b-col sm="4" class="mt-4">
                    <datepicker input-class="datepicker" v-model.trim="$v.firstDate.$model"
                        :placeholder="$t('action.chooseFirstDate')" :language="language" :disabledDates="disabledFirstDate">
                    </datepicker>
                    <div class="text-danger" v-if="!$v.firstDate.required && $v.firstDate.$dirty">{{ $t("info.required") }}
                    </div>
                </b-col>
            </b-row>

            <b-row class="mt-2">
                <b-col sm="4" class="mt-4">
                    <datepicker input-class="datepicker" v-model.trim="$v.secondDate.$model"
                        :placeholder="$t('action.chooseSecondDate')" :language="language"
                        :disabledDates="disabledSecondDate">
                    </datepicker>
                    <div class="text-danger" v-if="!$v.secondDate.required && $v.secondDate.$dirty">{{ $t("info.required")
                    }}
                    </div>
                </b-col>
            </b-row>

            <b-row class="pt-4">
                <b-col class="mt-2">
                    <b-button variant="success" :disabled="disabled" @click="batchRemoval()">{{
                        $t("action.remove")
                    }}</b-button>
                </b-col>
            </b-row>
        </div>

        <div v-if="error" class="pt-4">
            <b-alert show variant="danger">
                <p>{{ error }}</p>
            </b-alert>
        </div>
    </b-container>
</template>
  
<script>
import axios from "axios";
import moment from 'moment';
import { mappBuildingDataForSelect } from "../../../assets/Utils.js";
import { globalF } from "../../Helpers";
import Datepicker from "vuejs-datepicker";
import { en, fr } from "vuejs-datepicker/dist/locale";
import { required } from 'vuelidate/lib/validators';

export default {
    mixins: [globalF],
    data() {
        return {
            error: "",
            success: false,
            buildings: [],
            building: null,
            cleanUp: null,
            spinner: false,
            firstDate: "",
            secondDate: "",
            disabled: false
        };
    },
    validations() {
        return {
            building: {
                required
            },
            cleanUp: {
                required
            },
            firstDate: {
                required
            },
            secondDate: {
                required
            }
        }
    },
    mounted() {
        this.getBuildingList();
    },
    computed: {
        url: function () {
            return this.getUrl();
        },
        cleanUpTypeList: function () {
            return [
                {
                    text: this.$t('label.cleanupType'),
                    value: null
                },
                {
                    text: "Prospect",
                    value: "prospectSession"
                },
                {
                    text: "Lead",
                    value: "lead"
                }
            ]
        },
        language: function () {
            return this.$i18n.locale === "fr" ? fr : en;
        },
        disabledFirstDate: function () {
            let today = this.getMaxDateForDatePicker();
            let myDate = "";
            return { from: today, to: myDate};
        },
        disabledSecondDate: function () {
            let today = moment().endOf('day').toDate();
            let myDate = this.getMinDateForDatePicker();
            return { from: today, to: myDate };
        }
    },
    methods: {
        getMaxDateForDatePicker() {
            let max = moment().endOf('day').toDate();
            if (moment(this.secondDate).isValid()) {
                max = moment(this.secondDate).startOf('day').toDate();
            }
            return max;
        },
        getMinDateForDatePicker() {
            let min = moment().endOf('day').toDate();
            if (moment(this.firstDate).isValid()) {
                min = moment(this.firstDate).startOf('day').toDate();
            }
            return min;
        },
        getBuildingList() {
            this.spinner = true;
            let urls = this.$store.getters.getUrlsList;
            let url = urls[process.env.VUE_APP_WHERE].json;

            let promise = this.validateToken();
            promise.then(() => {
                axios
                    .post(
                        url,
                        { request: "getBuildingList" },
                        { headers: { "Content-Type": "application/json" } }
                    )
                    .then((response) => {
                        this.spinner = false;
                        this.setBuildingList(response.data.buildings);
                    })
                    .catch(() => {
                        this.spinner = false;
                        this.error = this.$t("info.errorgeneric");
                    });
            });
        },
        setBuildingList: function (buildings) {
            let res = [];
            if (buildings) {
                res = mappBuildingDataForSelect(buildings);
                //res.unshift({value: 'All', text: this.$t('label.all')});
            }
            res.unshift({ value: null, text: this.$t("label.properties") });
            this.buildings = res;
        },
        batchRemoval() {
            this.error = "";
            this.$v.$touch();
            if (!this.$v.$invalid) {
                this.spinner = true;
                let firstDate = moment(this.firstDate).format("YYYY-MM-DD");
                let secondDate = moment(this.secondDate).format("YYYY-MM-DD");

                axios
                    .post(
                        this.url,
                        {
                            request: "batchRemoval",
                            NOCIE: this.building.NOCIE,
                            NODIV: this.building.NODIV,
                            type: this.cleanUp,
                            firstDate: firstDate,
                            secondDate: secondDate
                        },
                        { headers: { "Content-Type": "application/json" } }
                    )
                    .then(() => {
                        this.success = true;
                        this.disabled = false;
                        this.spinner = false;
                    })
                    .catch((error) => {
                        this.error = error;
                        this.disabled = false;
                        this.spinner = false;
                    });
            }

        },
        setNextPage(page) {
            this.$emit("changePage", page);
        },
    },
    components: {
        Datepicker
    },
};
</script>
  